import * as React from "react";
import {none, option, Option} from "ts-option";
import {BillOfMaterialsPreviewDetails} from "../../../../model/job/BillOfMaterialsPreviewDetails";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import Routes from "../../../../navigation/route/Route";
import MerchantPreferences from "../MerchantPreferences";
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";
import {RouteComponentProps, RouteProps, withRouter} from "react-router";
import IconWrapper from "../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import Toast from "../../../helper/Toast";
import {BillOfMaterialsPreviewItems} from "../../../../model/job/BillOfMaterialsPreviewItems";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import DropDownList from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect, Dispatch} from "react-redux";
import Job from "../../../../model/job/Job";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import MerchantBranchSelectionModal from "./merchantBranchLocationSelection/MerchantBranchSelectionModal";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import MerchantBranchLocation from "../../../../model/merchant/MerchantBranchLocation";
import {OnFailure, OnSuccessData} from "../../../../store/action/actionHelpers";
import {createBillOfMaterial} from "../../../../store/action/billOfMaterials/billOfMaterials";
import "../../../accounting/common/commonDetailsStatusRow.scss";
import {Bom} from "../../../../model/job/Bom";
import Merchant from "../../../../model/merchant/Merchant";
import {fetchMerchants} from "../../../../store/action/merchant/merchant";
import {noop} from "react-select/lib/utils";

interface ComponentProps {
	/**
	 * Job object
	 */
	job: Job;
	/**
	 * Bill of materials details
	 */
	billOfMaterialsDetails: BillOfMaterialsPreviewDetails | Bom;
	/**
	 * Indicates if BoM is defined for job
	 */
	isBomDefinedForJob: boolean;
	/**
	 * If true, bom is read only.
	 */
	readOnly: boolean;
	/**
	 * Generate Bill action
	 */
	onGenerateBillClick: () => void;
	/**
	 * Is generate bill loading
	 */
	isGenerateBillLoading: boolean
}

interface ReduxProps {
	/**
	 * Indicates if the user has the option of select merchant for ordering
	 */
	selectForOrderingEnabled: boolean;
	/**
	 * Merchant
	 */
	merchant: Option<Merchant>
}

interface DispatchProps {
	createBillOfMaterials: (jobId: string,
		merchantId: string,
		onSuccess: OnSuccessData<Bom>,
		onFailure: OnFailure) => void,
	fetchMerchants: () => void
}

interface State {
	/**
	 * Show actions button dropdown menu visibility
	 */
	showActionsDropDownMenuVisible: boolean;
	/**
	 * Indicates if merchant branch selection modal is visible
	 */
	showMerchantBranchSelectionModal: boolean;
	/**
	 * Merchant branch locations
	 */
	merchantBranchLocations: Option<MerchantBranchLocation[]>
}

type Props = ReduxProps & ComponentProps & RouteComponentProps<RouteProps> & DispatchProps;

class JobBillOfMaterialsDetailsHeader extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state =
			{showActionsDropDownMenuVisible: false, showMerchantBranchSelectionModal: false, merchantBranchLocations: none};
		this.copyList = this.copyList.bind(this);
	}

	componentDidMount(): void {
		const isBom = this.props.billOfMaterialsDetails instanceof Bom
		if (!isBom) {
			this.fetchMerchantBranchLocation((this.props.billOfMaterialsDetails as BillOfMaterialsPreviewDetails).merchant.id)
		}
		else if (this.props.merchant.isDefined) {
			this.fetchMerchantBranchLocation(this.props.merchant.get.id)
		}
		else {
			this.props.fetchMerchants()
		}
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		if (this.props.merchant.isEmpty && nextProps.merchant.isDefined) {
			this.fetchMerchantBranchLocation(nextProps.merchant.get.id)
		}
	}

	render() {
		const {bomDetails = this.props.billOfMaterialsDetails} = {}
		const isBom = bomDetails instanceof Bom;
		const merchantName = isBom ? this.props.merchant.map(m => m.name).getOrElse("") :
			(bomDetails as BillOfMaterialsPreviewDetails).merchant.name
		return (
			<>
				<div className="c-common-status">
					<div className="c-common-status_ref-nums-container">
						<div style={{display: "inline"}}>
							<div className="c-common-status_lead-ref-num is-clickable" onClick={this.redirectToJob}>
								Job ID# {this.props.job.referenceNumber}
							</div>
							<div className="c-common-status_ref-num-arrow">
								<IconWrapper variant={"lighterBlue"} icon={Icon.ArrowRight} size={11}/>
							</div>
						</div>
						<div className="c-common-status_lead-ref-num is-clickable" onClick={this.redirectToJobBOM}>
							Merchants
						</div>
						<div className="c-common-status_ref-num-arrow">
							<IconWrapper variant={"lighterBlue"} icon={Icon.ArrowRight} size={11}/>
						</div>
						<div className="c-common-status_quote-ref-num">{merchantName}</div>
					</div>
					<div className="c-common-status_row-container">
						<div className="c-common-status_back-button-container" onClick={this.props.history.goBack}>
							<IconLarge variant={"burgundy"} icon={Icon.ArrowLeft}/>
						</div>
						<div className="c-common-status_quote-icon-container">
							<IconWrapper icon={Icon.Merchant} viewBoxFromSize={true} size={21}/>
						</div>
						<div className="job-bill-of-materials_merchant-text">
							<span className="job-bill-of-materials_merchant-text_merchant-name">{merchantName}</span>
							{!isBom && (bomDetails as BillOfMaterialsPreviewDetails).merchant.preferredBy.map(preferredBy => (
								<div style={{display: "inline", marginRight: "24px"}}>
									<MerchantPreferences merchantPreferredBy={preferredBy}/>
								</div>
							)).orNull}
							{!isBom && (bomDetails as BillOfMaterialsPreviewDetails).incomplete &&
							<div style={{display: "inline"}}>
								<div className={'circle-wrapper sm red'}><i className={'fas fa-exclamation'}/></div>
								<span className={'has-error'}>Order list incomplete</span>
							</div>}
						</div>
						<div className="job-bill-of-materials_buttons-container">
							{this.state.merchantBranchLocations.getOrElse([]).length > 0 && isBom &&
							<ButtonSecondary label={"View Branch"} onClick={this.viewBranch}/>}
							<div className="job-bill-of-materials_button-wrapper">
								<ButtonSecondary label={"Copy list (Table)"} onClick={this.copyList}/>
							</div>
							{isBom ?
								<div className={'job-bill-of-materials_button-wrapper'}>
									<ButtonPrimary onClick={this.props.onGenerateBillClick}
												   label={"Generate Bill"}
												   variant={"burgundy"}
												   disabled={this.props.readOnly}
												   isLoading={this.props.isGenerateBillLoading}/>
								</div>
								: this.renderOderActionsButton()
							}
						</div>
					</div>
				</div>
				{bomDetails instanceof Bom && <div className="job-bill-of-materials_bom-indicator">
					Selected as Bill of Materials
				</div>}
				{this.state.showMerchantBranchSelectionModal &&
				<MerchantBranchSelectionModal
					onCancel={() => this.setState({showMerchantBranchSelectionModal: false})}
					merchantName={merchantName}
					customerId={this.props.job.data.principalContactId}
					bom={bomDetails as Bom}
					merchantBranchLocations={this.state.merchantBranchLocations.getOrElse([])}
					jobId={this.props.job.id}
				/>
				}
			</>
		);
	}

	renderOderActionsButton() {
		let dropdownItems: DictionaryItem[] = [];
		if (this.props.selectForOrderingEnabled) {
			dropdownItems.push(new DictionaryItem(ShowAction.ORDER, 'Select this merchant for ordering'));
		}
		let actionsDisabled: string[] = [];
		if (this.props.isBomDefinedForJob || this.props.readOnly) {
			actionsDisabled.push(ShowAction.ORDER);
		}

		return (
			dropdownItems.length > 0 &&
			<div style={{display: "inline-flex", marginLeft: "15px"}}>
				<div style={{position: "relative"}}>
					<button className={'a-button-primary burgundy'}
							onClick={() => this.setState({showActionsDropDownMenuVisible: true})}>
						<span style={{marginRight: "5px"}}>Order actions</span> <i className={'fa fa-fw fa-caret-down'}/>
					</button>
					{this.state.showActionsDropDownMenuVisible &&
					<DropDownWrapper onOutsideClick={() => this.setState({showActionsDropDownMenuVisible: false})}>
						<DropDownList items={dropdownItems}
									  onSelect={(item: DictionaryItem) => this.setState({showActionsDropDownMenuVisible: false},
										  () => this.onShowSelectActionClick(item.id))}
									  itemToId={(item: DictionaryItem) => item.id}
									  itemToLabel={(item: DictionaryItem) => item.name}
									  itemDisabled={(item: DictionaryItem) => actionsDisabled.indexOf(item.id) > -1}/>
					</DropDownWrapper>}
				</div>
			</div>
		);
	}

	fetchMerchantBranchLocation = (merchantId: string) => {
		api.instance.merchantApi.fetchMerchantBranchLocations(merchantId).then(
			(merchantBranchLocations: MerchantBranchLocation[]) => {
				const showMerchantBranchSelectionModal = this.props.location.state &&
					this.props.location.state.openBranchLocation && !!merchantBranchLocations.length
				this.setState({merchantBranchLocations: option(merchantBranchLocations), showMerchantBranchSelectionModal})
			});
	}

	onShowSelectActionClick(showActionId: string) {
		switch (showActionId) {
			case ShowAction.ORDER:
				this.selectForOrdering();
				return;
		}
	}

	viewBranch = () => {
		this.setState({showMerchantBranchSelectionModal: true});
	};

	selectForOrdering() {
		api.instance.jobBillOfMaterialsApi.createBillOfMaterials(this.props.job.id,
			(this.props.billOfMaterialsDetails as BillOfMaterialsPreviewDetails).merchant.id)
			.then(bom =>
				this.props.history.replace(Routes.BillOfMaterialsDetails(this.props.job.referenceNumber, bom.id),
					{openBranchLocation: true})
			)
			.catch(error => {
				notifyBugsnagAndShowToast(error, "Select merchant for ordering");
			})
	}

	redirectToJob = () => this.props.history.push(Routes.EditJob(this.props.job.referenceNumber));

	redirectToJobBOM = () => this.props.history.push(Routes.BillOfMaterials(this.props.job.referenceNumber));

	copyList() {
		BillOfMaterialsPreviewItems.copyToClipboard(this.props.billOfMaterialsDetails.items.assets);
		Toast.success("Table has been copied successfully", "Copy to clipboard");
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const isBom = props.billOfMaterialsDetails instanceof Bom
	return {
		selectForOrderingEnabled: state.user.user.map(user => user.isAgent() || user.isAdmin()).getOrElse(false),
		merchant: isBom ? option(
			state.merchant.merchants.getOrElse([]).filter(m => m.id == (props.billOfMaterialsDetails as Bom).merchantId)[0]) :
			none
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createBillOfMaterials: (jobId: string,
			merchantId: string,
			onSuccess: OnSuccessData<Bom>,
			onFailure: OnFailure) =>
			dispatch(createBillOfMaterial(jobId, merchantId, onSuccess, onFailure)),
		fetchMerchants: () => dispatch(fetchMerchants(noop, noop))
	}
}

export default withRouter<ComponentProps>(connect(mapStateToProps, mapDispatchToProps)(JobBillOfMaterialsDetailsHeader));

enum ShowAction {
	ORDER = 'ORDER'
}
